import { toastState } from '../../models/callModel';
import { Types } from '../action/action';

const initialState = {
  message: '',
  mode: '',
  isLeftToast: '',
  isEnableUndo:  false,
  undoIt:false,
  toastMessage:'',
  meetingNotify:{},
  callback:'',
  undo: false,
  key: "",
  internet: false
};

export const toastReducer = (state:toastState  = initialState, action: any) => {
  const {
    type,
    payloads
  } = action;
  switch (type) {
  case Types.TOAST_INFO:
    return {
      ...state, message: payloads.message, mode: payloads.mode, isLeftToast: payloads.isLeftToast
    };
  case Types.UNDO_TOAST:
    return {
      ...state,  isLeftToast: payloads.isLeftToast,
      isEnableUndo: payloads.isEnableUndo, undoIt:payloads.undoIt
    };
    case Types.TOAST_UNDO:
    return {
      ...state, toastMessage: payloads.toastMessage, callback:payloads.callback
    };
    case Types.TOAST_UNDO_CLICK:
      return {
        ...state, undo: payloads.undo, key: payloads.key
      };
      case Types.CHECK_INTERNET:
        return {
          ...state, internet: payloads.internet
        };
        case Types.MEETING_NOTIFY:
          return {
            ...state, meetingNotify: payloads.meetingNotify
          };
  default:
    return state;
  };
};